export var LIFE_CYCLE_TYPE;
(function (LIFE_CYCLE_TYPE) {
    /**
     * 当表单初始化时触发
     */
    LIFE_CYCLE_TYPE["ON_INITIALIZED"] = "onInitialized";
    /**
     * 表单值变更时触发
     */
    LIFE_CYCLE_TYPE["ON_VALUE_CHANGE"] = "onValueChange";
    /**
     * 表单任意状态变更时触发
     */
    LIFE_CYCLE_TYPE["ON_STATE_CHANGE"] = "onStateChange";
    /**
     *  调用 api validate 时触发，validate 只会校验节点自己，不会校验其他节点
     *  注意：当子节点调用 validateWithAllParent
     *       或者父节点调用 validateWithAllChildren, validateValue 时也会触发此事件
     *       因为所有的校验最底层调用的都是 validate 方法
     */
    LIFE_CYCLE_TYPE["ON_VALIDATE_START"] = "onValidateStart";
    LIFE_CYCLE_TYPE["ON_VALIDATE_END"] = "onValidateEnd";
    LIFE_CYCLE_TYPE["ON_VALIDATE_SUCCESS"] = "onValidateSuccess";
    LIFE_CYCLE_TYPE["ON_VALIDATE_FAILED"] = "onValidateFailed";
    /**
     *  调用 api validateValue 开始/结束 时触发
     */
    LIFE_CYCLE_TYPE["ON_VALIDATE_VALUE_START"] = "onValidateValueStart";
    LIFE_CYCLE_TYPE["ON_VALIDATE_VALUE_END"] = "onValidateValueEnd";
    /**
     *  调用 api validateValue 成功/失败 时触发
     */
    LIFE_CYCLE_TYPE["ON_VALIDATE_VALUE_SUCCESS"] = "onValidateValueSuccess";
    LIFE_CYCLE_TYPE["ON_VALIDATE_VALUE_FAILED"] = "onValidateValueFailed";
    /**
     * 表单节点被重置后触发
     * 父节点触发 reset 时，所有子节点也会触发此事件
     */
    LIFE_CYCLE_TYPE["ON_RESET"] = "onReset";
    // /**
    //  * 调用 api validateWithAllChildren, validateValue 时触发
    //  */
    // ON_VALIDATE_WITH_ALL_CHILDREN_START = 'onValidateWithAllChildrenStart',
    // ON_VALIDATE_WITH_ALL_CHILDREN_END = 'onValidateWithAllChildrenEnd',
    // /**
    //  * 调用 api validateWithAllParent 时触发
    //  */
    // ON_VALIDATE_WITH_ALL_PARENT_START = 'onValidateWithAllParentStart',
    // ON_VALIDATE_WITH_ALL_PARENT_END = 'onValidateWithAllParentEnd',
})(LIFE_CYCLE_TYPE || (LIFE_CYCLE_TYPE = {}));
